<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard>
                <CCardHeader class="d-flex align-items-center flex-wrap justify-content-between pb-0 header-with-nav">
                    <strong>Отчеты</strong>
                </CCardHeader>
                <CCardBody>
                    <PartnersTabLinks />
                </CCardBody>
            </CCard>
            <CCard>
                <CCardBody>
                    <CCard class="p-4 mt-2">
                        <CRow class="mb-1 ml-1 d-flex align-items-center justify-content-between">
                            <CCol class="h4 mb-0 p-0">Агентский отчет</CCol>
                            <CCol class="d-flex align-items-center justify-content-end">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="showFilters"
                                    class="ml-2" />
                                <span class="ml-2">Настройки/Экспорт</span>
                            </CCol>
                        </CRow>
                        <CRow v-if="showFilters" class="ml-1 mb-1 align-items-center">
                            <CCol>
                                <CRow class="mt-2">
                                    <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                        <span class="mr-1">Показать оплату</span>
                                    </CCol>
                                    <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                        <CSwitch
                                            color="dark"
                                            shape="pill"
                                            variant="opposite"
                                            :checked.sync="showDifference"
                                        />
                                    </CCol>
                                </CRow>
                                <CRow class="mt-2">
                                    <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                        <span class="mr-1">Дата начала</span>
                                    </CCol>
                                    <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                        <DatePicker
                                            v-model="datepicker.dateFrom"
                                            :language="datepicker.lang"
                                            :format="datepicker.format"
                                            input-class="custom-datepicker"
                                            placeholder="Выберите дату..."
                                        />
                                    </CCol>
                                </CRow>
                                <CRow class="mt-2">
                                    <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                        <span class="mr-1">Дата окончания</span>
                                    </CCol>
                                    <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                        <DatePicker
                                            v-model="datepicker.dateTo"
                                            :language="datepicker.lang"
                                            :format="datepicker.format"
                                            input-class="custom-datepicker"
                                            placeholder="Выберите дату..."
                                        />
                                    </CCol>
                                </CRow>
                                <CRow class="mt-2">
                                    <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                        <span class="mr-1">Фильтровать по</span>
                                    </CCol>
                                    <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                        <CSelect
                                            :horizontal="true"
                                            class="w-full"
                                            input-class="form-control custom-datepicker mb-0"
                                            :value.sync="exportFilter"
                                            :options="exportFilterOptions"
                                        />
                                    </CCol>
                                </CRow>
                                <CRow class="mt-2">
                                    <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                        <span class="mr-1">Включить Отмененные/Инциденты</span>
                                    </CCol>
                                    <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                        <CSwitch
                                            color="dark"
                                            shape="pill"
                                            variant="opposite"
                                            :checked.sync="exportCanceled"
                                        />
                                    </CCol>
                                </CRow>
                                <CRow class="mt-2">
                                        <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                            <span class="mr-1">Выручка приходит к партнеру</span>
                                        </CCol>
                                        <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                            <CSwitch
                                                color="dark"
                                                shape="pill"
                                                variant="opposite"
                                                :checked.sync="partnerRevenue"
                                            />
                                        </CCol>
                                    </CRow>
                                <CRow class="mt-2">
                                    <CCol
                                        cols="12"
                                        class="mt-2 flex">
                                        <CButton color="primary" :disabled="processStarted" @click="doExport">Экспорт</CButton>
                                        <CButton color="primary" class="ml-2" :disabled="processStarted" @click="doSendExport">Экспортировать и отправить всем получателям</CButton>
                                    </CCol>
                                </CRow>
                                <CRow v-if="processStarted" class="mt-2">
                                    <CCol cols="12" class="mt-2 flex">
                                        {{ exportMessage }}
                                        <CLink to="/export">{{ exportFile }}</CLink>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                    </CCard>
                    <ReportTable :list.sync="items" :show-difference.sync="showDifference" />
                    <CPagination
                        :active-page.sync="activePage"
                        class="mt-4"
                        :pages="total"
                        align="center"
                    />
                </CCardBody>
            </CCard>
        </CCol>
        <CustomExport :partner.sync="partner" />
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnersTabLinks from '@/components/partner/PartnersTabLinks';
    import ReportTable from '@/components/partner/ReportTable';
    import CustomExport from '@/components/CustomExport';
    import DatePicker from 'vuejs-datepicker';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import moment from 'moment';
    import { ORDER_STATUS } from '../../utils/order';
    const { ITEMS_PER_PAGE } = require('../../utils/views');

    export default {
        name: 'PartnerReports',

        components: {
            PartnersTabLinks,
            ReportTable,
            DatePicker,
            CustomExport
        },

        data() {
            return {
                items: [],
                total: 1,
                timerId: null,
                sorter: '',
                filter: '',
                showFilters: false,
                showDifference: false,
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    dateFrom: null,
                    dateTo: null,
                },
                partner: {},
                processStarted: false,
                exportMessage: '',
                exportFile: '',
                exportFilter: ORDER_STATUS.DONE,
                exportFilterOptions: [
                    { value: ORDER_STATUS.DONE, label: 'По дате завершения' },
                    { value: ORDER_STATUS.PAID, label: 'По дате оплаты' },
                ],
                exportCanceled: false,
                partnerRevenue: false,
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
        },

        watch: {
            activePage: 'fetchOrders',
            sorter: 'fetchOrders',
            filter: 'fetchOrders'
        },

        async mounted() {
            await this.fetchOrders();
            const partner = (await Vue.axios.get(`/partners/${this.$route.params.id}/`)).data;
            this.partner = partner;
        },

        methods: {
            async fetchOrders() {
                try {
                    const params = {
                        page: this.activePage,
                        pageSize: ITEMS_PER_PAGE,
                        main: 1,
                        sorter: this.sorter,
                        partner_id: this.$route.params.id,
                    };
            
                    const { data } = await Vue.axios
                        .get(`/partners/${this.$route.params.id}/report/agent`, { params });
                    this.items = data.results;
                    this.total = Math.ceil(data.total / ITEMS_PER_PAGE);
                } catch (e) {
                    console.log(e);
                }
            },

            doExport({ sendToEmail = false }) {
                if (!this.datepicker.dateFrom || !this.datepicker.dateTo) {
                    this.$root.$emit('showError', 'Укажите даты начала и окончания для экспорта');
                    return;
                }
                const filters = {
                    status: this.exportFilter,
                    canceled: this.exportCanceled,
                    partnerRevenue: this.partnerRevenue,
                }
                const dateFrom = moment(Date.parse(this.datepicker.dateFrom)).format('YYYY-MM-DD');
                const dateTo = moment(Date.parse(this.datepicker.dateTo)).format('YYYY-MM-DD');
                this.axios.get(
                    `/export/partners/${this.$route.params.id}?dateFrom=${dateFrom}&dateTo=${dateTo}&filter=${JSON.stringify(filters)}&difference=${this.showDifference}&sendToEmail=${sendToEmail}`
                ).then(res => {
                    this.exportMessage = res.data.message;
                    this.exportFile = res.data.filename;
                });
                this.processStarted = true;
            },
            doSendExport() {
                this.doExport({ sendToEmail: true });
            }
        },
    };
</script>

<style>
input.custom-datepicker {
  border: 1px solid;
  border-color: #d8dbe0;
  width: 100%;
}
.header-with-nav ul.nav.nav-tabs {
    border-bottom: 0;
}
</style>
